import axios from "axios";

export const $axios = axios.create({
    baseURL: process.env.VUE_APP_AMAZON_WS_API_URL,
    method: "post",
    headers: {
        'Content-Type': 'application/json'
    },
});